import React, {Component} from 'react';
import {Modal} from 'antd';
import Toast from '@/components/Toast';

declare var $: any;
type Result = {
    token: string;
    [name: string]: any;
};
type CaptchaType = {
    captchaId: string;
    remoteUrl: string;
    show: boolean;
    // eslint-disable-next-line no-unused-vars
    onSuccess?: (arg0: Result) => void;
    onError?: () => void;
};

// eslint-disable-next-line no-unused-vars
class Captcha extends Component<CaptchaType, CaptchaType> {
    constructor(props: CaptchaType) {
        super(props);
        this.state = {...props};
    }

    componentDidUpdate(): void {
        if (this.props.show) {
            setTimeout(() => {
                this.registerCaptcha();
            }, 10);
        }
    }

    registerCaptcha() {
        $('#captcha').sliderCaptcha({
            captchaId: this.props.captchaId,
            remoteUrl: this.props.remoteUrl,
            width: '292',
            height: '150',
            onSuccess: (res: any) => {
                let token = res.data.token,
                    result: Result = {
                        token,
                        checkoutVisible: false
                    };
                if (this.props.onSuccess) this.props.onSuccess(result);
            },
            onFail: () => {
                Toast.info('验证失败');
            },
            onError: () => {
                Toast.info('网络异常，请检查网络');
                this.registerCaptcha();
            }
        });
    }

    render(): React.ReactNode {
        return (
            <Modal footer={null} destroyOnClose={true} closable={false} open={this.props.show}>
                <div className="form-row">
                    <div className="slidercaptcha card">
                        <div className="card-body">
                            <div id="captcha"></div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default Captcha;
